

// // import { useState, useEffect, useRef } from "react";
// // import { 
// //   FaChevronDown, 
// //   FaSearch, 
// //   FaBars, 
// //   FaTimes, 
// //   FaBuilding 
// // } from "react-icons/fa";
// // import "./Navbar-test.css";
// // import { NAV_DATA, LOGO_URL } from "../data/navData";
// // import { Link } from "react-router-dom";

// // export default function Navbar() {
// //   const [openIdx, setOpenIdx] = useState(null);
// //   const [mobileOpen, setMobileOpen] = useState(false);
// //   const [mobileSub, setMobileSub] = useState(null);
// //   const [query, setQuery] = useState("");
// //   const [scrolled, setScrolled] = useState(false);
// //   const navRef = useRef(null);

// //   useEffect(() => {
// //     const onScroll = () => setScrolled(window.scrollY > 8);
// //     window.addEventListener("scroll", onScroll);
// //     return () => window.removeEventListener("scroll", onScroll);
// //   }, []);

// //   useEffect(() => {
// //     const onClick = (e) => {
// //       if (navRef.current && !navRef.current.contains(e.target)) {
// //         setOpenIdx(null);
// //       }
// //     };
// //     document.addEventListener("mousedown", onClick);
// //     return () => document.removeEventListener("mousedown", onClick);
// //   }, []);

// //   // Helper function to check if URL is PDF
// //   const isPdfLink = (href) => {
// //     return href && href.toLowerCase().endsWith('.pdf');
// //   };

// //   return (
// //     <header ref={navRef} className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}>
// //       {/* Top Bar */}
// //       <div className="topbar">
// //         <div className="container topbar-inner" style={{ maxWidth: "1350px" }}>
// //           <Link to='/'>
// //             <div className="logo">
// //               <img src={LOGO_URL} alt="ASSOCHAM" />
// //             </div>
// //           </Link>
// //           <div className="search-bar">
// //             <input 
// //               className="search-input"
// //               placeholder="Search ASSOCHAM..."
// //               value={query}
// //               onChange={(e) => setQuery(e.target.value)}
// //             />
// //             <button className="search-icon_btn"><FaSearch size={18} /></button>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Main Navbar */}
// //       <div className="nav-container nav-main">
// //         <nav className="nav-links">
// //           {NAV_DATA.map((item, idx) => {
// //             const hasDropdown = item.items && item.items.length > 0;
// //             const isActive = openIdx === idx;

// //             return (
// //               <div
// //                 key={item.label}
// //                 className={`nav-item ${hasDropdown && isActive ? "nav-item-active" : ""}`}
// //                 onMouseEnter={() => hasDropdown && setOpenIdx(idx)}
// //                 onMouseLeave={() => hasDropdown && setOpenIdx(null)}
// //               >
// //                 {item.href ? (
// //                   <Link 
// //                     to={item.href} 
// //                     className="nav-button"
// //                     {...(isPdfLink(item.href) ? { target: "_blank", rel: "noopener noreferrer" } : {})}
// //                   >
// //                     {item.label}
// //                   </Link>
// //                 ) : (
// //                   <button className="nav-button">{item.label}</button>
// //                 )}

// //                 {/* Dropdown Menu */}
// //                 {hasDropdown && isActive && (
// //                   <div className={`dropdown ${item.columns ? "mega" : "normal"}`}>
// //                     <div className={item.columns ? "mega-menu-grid" : ""}>
// //                       {item.items.map((sub, subIdx) => (
// //                         <Link
// //                           key={subIdx}
// //                           to={sub.href || "#"}
// //                           className={`dropdown-link text-[14px] py-2.5 px-5 ${item.columns ? "mega-link" : ""}`}
// //                           {...(isPdfLink(sub.href) ? { target: "_blank", rel: "noopener noreferrer" } : {})}
// //                         >
// //                           {item.columns && (
// //                             <FaBuilding className="text-[#cf121c] mr-2" size={14} />
// //                           )}
// //                           {sub.label || sub}
// //                         </Link>
// //                       ))}
// //                     </div>
// //                   </div>
// //                 )}
// //               </div>
// //             );
// //           })}
// //         </nav>

// //         {/* Right Side */}
// //         <div className="nav-actions">
// //           <a href="#" className="cta-btn">Join ASSOCHAM</a>
// //           <button className="mobile-toggle" onClick={() => setMobileOpen(true)}>
// //             <FaBars size={22} />
// //           </button>
// //         </div>
// //       </div>

// //       {/* Mobile Menu */}
// //       {mobileOpen && (
// //         <div className="mobile-overlay" onClick={() => setMobileOpen(false)}>
// //           <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
// //             <div className="mobile-header">
// //               <img src={LOGO_URL} alt="ASSOCHAM" />
// //               <FaTimes size={24} onClick={() => setMobileOpen(false)} />
// //             </div>

// //             {NAV_DATA.map((item, idx) => (
// //               <div key={item.label}>
// //                 {item.href ? (
// //                   <Link
// //                     to={item.href}
// //                     className="mobile-main-btn"
// //                     onClick={() => setMobileOpen(false)}
// //                     {...(isPdfLink(item.href) ? { target: "_blank", rel: "noopener noreferrer" } : {})}
// //                   >
// //                     {item.label}
// //                   </Link>
// //                 ) : (
// //                   <button
// //                     className="mobile-main-btn"
// //                     onClick={() => item.items && setMobileSub(mobileSub === idx ? null : idx)}
// //                   >
// //                     {item.label}
// //                     {item.items && <FaChevronDown size={14} />}
// //                   </button>
// //                 )}

// //                 {item.items && mobileSub === idx && (
// //                   <div className="mobile-sub">
// //                     {item.items.map((sub, i) => (
// //                       <Link
// //                         key={i}
// //                         to={sub.href || "#"}
// //                         className="mobile-sub-link"
// //                         onClick={() => setMobileOpen(false)}
// //                         {...(isPdfLink(sub.href) ? { target: "_blank", rel: "noopener noreferrer" } : {})}
// //                       >
// //                         {sub.label || sub}
// //                       </Link>
// //                     ))}
// //                   </div>
// //                 )}
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       )}
// //     </header>
// //   );
// // }  





// // new new code 





// import { useState, useEffect, useRef } from "react";
// import { 
//   FaChevronDown, 
//   FaSearch, 
//   FaBars, 
//   FaTimes, 
//   FaBuilding 
// } from "react-icons/fa";
// import "./Navbar.css";
// import { NAV_DATA, LOGO_URL } from "../data/navData";
// import { Link } from "react-router-dom";

// export default function Navbar() {
//   const [openIdx, setOpenIdx] = useState(null);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [mobileSub, setMobileSub] = useState(null);
//   const [query, setQuery] = useState("");
//   const [scrolled, setScrolled] = useState(false);
//   const navRef = useRef(null);

//   useEffect(() => {
//     const onScroll = () => setScrolled(window.scrollY > 8);
//     window.addEventListener("scroll", onScroll);
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   useEffect(() => {
//     const onClick = (e) => {
//       if (navRef.current && !navRef.current.contains(e.target)) {
//         setOpenIdx(null);
//       }
//     };
//     document.addEventListener("mousedown", onClick);
//     return () => document.removeEventListener("mousedown", onClick);
//   }, []);

//   const isPdfLink = (href) => {
//     return href && href.toLowerCase().endsWith('.pdf');
//   };

//   return (
//     <header ref={navRef} className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}>
//       {/* Top Bar */}
//       <div className="topbar">
//         <div className="container topbar-inner" style={{ maxWidth: "1350px" }}>
//           <Link to='/'>
//             <div className="logo">
//               <img src={LOGO_URL} alt="ASSOCHAM" />
//             </div>
//           </Link>
//           <div className="search-bar">
//             <input 
//               className="search-input"
//               placeholder="Search ASSOCHAM..."
//               value={query}
//               onChange={(e) => setQuery(e.target.value)}
//             />
//             <button className="search-icon_btn"><FaSearch size={18} /></button>
//           </div>
//         </div>
//       </div>

//       {/* Main Navbar */}
//       <div className="nav-container nav-main">
//         <nav className="nav-links">
//           {NAV_DATA.map((item, idx) => {
//             const hasDropdown = item.items && item.items.length > 0;
//             const isActive = openIdx === idx;

//             return (
//               <div
//                 key={item.label}
//                 className={`nav-item ${hasDropdown && isActive ? "nav-item-active" : ""}`}
//                 onMouseEnter={() => hasDropdown && setOpenIdx(idx)}
//                 onMouseLeave={() => hasDropdown && setOpenIdx(null)}
//               >
//                 {item.href ? (
//                   <Link 
//                     to={item.href} 
//                     className="nav-button"
//                     {...(isPdfLink(item.href) ? { target: "_blank", rel: "noopener noreferrer" } : {})}
//                   >
//                     {item.label}
//                     {hasDropdown && (
//                       <FaChevronDown
//                         size={11}
//                         className="nav-arrow"
//                         style={{
//                           marginLeft: 6,
//                           transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
//                           transition: "transform 0.2s ease",
//                         }}
//                       />
//                     )}
//                   </Link>
//                 ) : (
//                   <button className="nav-button">
//                     {item.label}
//                     {hasDropdown && (
//                       <FaChevronDown
//                         size={11}
//                         className="nav-arrow"
//                         style={{
//                           marginLeft: 6,
//                           transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
//                           transition: "transform 0.2s ease",
//                         }}
//                       />
//                     )}
//                   </button>
//                 )}

//                 {/* Dropdown Menu */}
//                 {hasDropdown && isActive && (
//                   <div className={`dropdown ${item.columns ? "mega" : "normal"}`}>
//                     <div className={item.columns ? "mega-menu-grid" : ""}>
//                       {item.items.map((sub, subIdx) => (
//                         <Link
//                           key={subIdx}
//                           to={sub.href || "#"}
//                           className={`dropdown-link text-[14px] py-2.5 px-5 ${item.columns ? "mega-link" : ""}`}
//                           {...(isPdfLink(sub.href) ? { target: "_blank", rel: "noopener noreferrer" } : {})}
//                         >
//                           {item.columns && (
//                             <FaBuilding className="text-[#cf121c] mr-2" size={14} />
//                           )}
//                           {sub.label || sub}
//                         </Link>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </nav>

//         {/* Right Side */}
//         <div className="nav-actions">
//           <a href="#" className="cta-btn">Join ASSOCHAM</a>
//           <button className="mobile-toggle" onClick={() => setMobileOpen(true)}>
//             <FaBars size={22} />
//           </button>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       {mobileOpen && (
//         <div className="mobile-overlay" onClick={() => setMobileOpen(false)}>
//           <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
//             <div className="mobile-header">
//               <img src={LOGO_URL} alt="ASSOCHAM" />
//               <FaTimes size={24} onClick={() => setMobileOpen(false)} />
//             </div>

//             {NAV_DATA.map((item, idx) => (
//               <div key={item.label}>
//                 {item.href ? (
//                   <Link
//                     to={item.href}
//                     className="mobile-main-btn"
//                     onClick={() => setMobileOpen(false)}
//                     {...(isPdfLink(item.href) ? { target: "_blank", rel: "noopener noreferrer" } : {})}
//                   >
//                     {item.label}
//                   </Link>
//                 ) : (
//                   <button
//                     className="mobile-main-btn"
//                     onClick={() => item.items && setMobileSub(mobileSub === idx ? null : idx)}
//                   >
//                     {item.label}
//                     {item.items && (
//                       <FaChevronDown
//                         size={14}
//                         style={{
//                           transform: mobileSub === idx ? "rotate(180deg)" : "rotate(0deg)",
//                           transition: "transform 0.2s ease",
//                         }}
//                       />
//                     )}
//                   </button>
//                 )}

//                 {item.items && mobileSub === idx && (
//                   <div className="mobile-sub">
//                     {item.items.map((sub, i) => (
//                       <Link
//                         key={i}
//                         to={sub.href || "#"}
//                         className="mobile-sub-link"
//                         onClick={() => setMobileOpen(false)}
//                         {...(isPdfLink(sub.href) ? { target: "_blank", rel: "noopener noreferrer" } : {})}
//                       >
//                         {sub.label || sub}
//                       </Link>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </header>
//   );
// }








// new new code 




import { useState, useEffect, useRef } from "react";

import {
  FaChevronDown,
  FaChevronRight,
  FaSearch,
  FaBars,
  FaTimes,
  FaBuilding,
} from "react-icons/fa";

import "./Navbar.css";
import { NAV_DATA, LOGO_URL } from "../data/navData";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [openIdx, setOpenIdx] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileSub, setMobileSub] = useState(null);
  const [mobileNestedSub, setMobileNestedSub] = useState(null);
  const [query, setQuery] = useState("");
  const [scrolled, setScrolled] = useState(false);

  const navRef = useRef(null);

  // nested dropdown state
  const [activeSector, setActiveSector] = useState(null);
  const [flyoutStyle, setFlyoutStyle] = useState({});
  const closeTimer = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 8);
    };

    window.addEventListener("scroll", onScroll);
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onClick = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpenIdx(null);
        setActiveSector(null);
      }
    };

    document.addEventListener("mousedown", onClick);

    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  useEffect(() => {
    setActiveSector(null);
  }, [openIdx]);

  useEffect(() => {
    const onResize = () => {
      setActiveSector(null);
    };

    window.addEventListener("resize", onResize);

    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    return () => clearTimeout(closeTimer.current);
  }, []);

  const isPdfLink = (href) => {
    return typeof href === "string" && href.toLowerCase().endsWith(".pdf");
  };

  const getLabel = (item) => {
    if (typeof item === "string") return item;
    return item?.label || "";
  };

  const getHref = (item) => {
    if (typeof item === "string") return "#";
    return item?.href || "#";
  };

  const getLinkProps = (href) => {
    if (isPdfLink(href)) {
      return {
        target: "_blank",
        rel: "noopener noreferrer",
      };
    }

    return {};
  };

  const handleSectorEnter = (e, sIdx, councilsCount = 0) => {
    clearTimeout(closeTimer.current);

    setActiveSector(sIdx);

    const rowRect = e.currentTarget.getBoundingClientRect();
    const flyoutWidth = 300;

    const estimatedHeight = Math.min(
      councilsCount * 38 + 16,
      window.innerHeight - 24
    );

    // horizontal position
    let left = rowRect.right + 4;

    if (left + flyoutWidth > window.innerWidth - 8) {
      left = rowRect.left - flyoutWidth - 4;
    }

    if (left < 8) {
      left = 8;
    }

    // vertical position
    let top = rowRect.top;

    if (top + estimatedHeight > window.innerHeight - 8) {
      top = Math.max(8, window.innerHeight - estimatedHeight - 8);
    }

    setFlyoutStyle({
      left,
      top,
      maxHeight: window.innerHeight - top - 16,
    });
  };

  const handleSectorLeave = () => {
    closeTimer.current = setTimeout(() => {
      setActiveSector(null);
    }, 150);
  };

  const handleFlyoutEnter = () => {
    clearTimeout(closeTimer.current);
  };

  const handleFlyoutLeave = () => {
    closeTimer.current = setTimeout(() => {
      setActiveSector(null);
    }, 150);
  };

  const closeMobileMenu = () => {
    setMobileOpen(false);
    setMobileSub(null);
    setMobileNestedSub(null);
  };

  return (
    <header
      ref={navRef}
      className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}
    >
      {/* Top Bar */}
      <div className="topbar">
        <div className="container topbar-inner">
          <Link to="/">
            <div className="logo">
              <img src={LOGO_URL} alt="ASSOCHAM" />
            </div>
          </Link>

          <div className="search-bar">
            <input
              className="search-input"
              placeholder="Search ASSOCHAM..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />

            <button className="search-icon-btn" type="button">
              <FaSearch size={18} />
            </button>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <div className="nav-container nav-main">
        <nav className="nav-links">
          {NAV_DATA.map((item, idx) => {
            const hasDropdown =
              Array.isArray(item.items) && item.items.length > 0;

            const isActive = openIdx === idx;
            const isNested = item.type === "nested";

            return (
              <div
                key={item.label}
                className={`nav-item ${
                  hasDropdown && isActive ? "nav-item-active" : ""
                }`}
                onMouseEnter={() => {
                  if (hasDropdown) setOpenIdx(idx);
                }}
                onMouseLeave={() => {
                  if (hasDropdown) setOpenIdx(null);
                }}
              >
                {item.href ? (
                  <Link
                    to={item.href}
                    className="nav-button"
                    {...getLinkProps(item.href)}
                  >
                    {item.label}

                    {hasDropdown && (
                      <FaChevronDown
                        size={11}
                        className="nav-arrow"
                        style={{
                          marginLeft: 6,
                          transform: isActive
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.2s ease",
                        }}
                      />
                    )}
                  </Link>
                ) : (
                  <button
                    type="button"
                    className="nav-button"
                    onClick={() => {
                      if (hasDropdown) {
                        setOpenIdx(isActive ? null : idx);
                      }
                    }}
                  >
                    {item.label}

                    {hasDropdown && (
                      <FaChevronDown
                        size={11}
                        className="nav-arrow"
                        style={{
                          marginLeft: 6,
                          transform: isActive
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.2s ease",
                        }}
                      />
                    )}
                  </button>
                )}

                {/* Dropdown Menu */}
                {hasDropdown &&
                  isActive &&
                  (isNested ? (
                    <div className="dropdown nested-dropdown">
                      <div className="sector-list">
                        {item.items.map((sector, sIdx) => {
                          const councils = Array.isArray(sector.councils)
                            ? sector.councils
                            : [];

                          return (
                            <div
                              key={sector.label}
                              className={`sector-row ${
                                activeSector === sIdx
                                  ? "sector-row-active"
                                  : ""
                              }`}
                              onMouseEnter={(e) =>
                                handleSectorEnter(e, sIdx, councils.length)
                              }
                              onMouseLeave={handleSectorLeave}
                            >
                              <span>{sector.label}</span>

                              <FaChevronRight
                                size={11}
                                className="sector-arrow"
                              />

                              {activeSector === sIdx && (
                                <div
                                  className="council-flyout"
                                  style={{
                                    position: "fixed",
                                    left: flyoutStyle.left,
                                    top: flyoutStyle.top,
                                    maxHeight: flyoutStyle.maxHeight,
                                  }}
                                  onMouseEnter={handleFlyoutEnter}
                                  onMouseLeave={handleFlyoutLeave}
                                >
                                  {councils.map((council, cIdx) => {
                                    const councilLabel = getLabel(council);
                                    const councilHref = getHref(council);

                                    return (
                                      <Link
                                        key={`${councilLabel}-${cIdx}`}
                                        to={councilHref}
                                        className="council-link"
                                        {...getLinkProps(councilHref)}
                                      >
                                        {councilLabel}
                                      </Link>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <div
                      className={`dropdown ${
                        item.columns ? "mega" : "normal"
                      }`}
                    >
                      <div className={item.columns ? "mega-menu-grid" : ""}>
                        {item.items.map((sub, subIdx) => {
                          const subLabel = getLabel(sub);
                          const subHref = getHref(sub);

                          return (
                            <Link
                              key={`${subLabel}-${subIdx}`}
                              to={subHref}
                              className={`dropdown-link ${
                                item.columns ? "mega-link" : ""
                              }`}
                              {...getLinkProps(subHref)}
                            >
                              {item.columns && (
                                <FaBuilding
                                  className="mega-link-icon"
                                  size={14}
                                />
                              )}

                              {subLabel}
                            </Link>
                          );
                        })}
                      </div>
                    </div>
                  ))}
              </div>
            );
          })}
        </nav>

        {/* Right Side */}
        <div className="nav-actions">
          <Link to="/join" className="cta-btn">
            Join ASSOCHAM
          </Link>

          <button
            type="button"
            className="mobile-toggle"
            onClick={() => setMobileOpen(true)}
          >
            <FaBars size={22} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="mobile-overlay" onClick={closeMobileMenu}>
          <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-header">
              <img src={LOGO_URL} alt="ASSOCHAM" />

              <button
                type="button"
                className="mobile-close"
                onClick={closeMobileMenu}
              >
                <FaTimes size={24} />
              </button>
            </div>

            {NAV_DATA.map((item, idx) => {
              const hasDropdown =
                Array.isArray(item.items) && item.items.length > 0;

              const isMobileActive = mobileSub === idx;

              return (
                <div key={item.label} className="mobile-item">
                  {hasDropdown ? (
                    <button
                      type="button"
                      className="mobile-main-btn"
                      onClick={() => {
                        setMobileNestedSub(null);
                        setMobileSub(isMobileActive ? null : idx);
                      }}
                    >
                      <span>{item.label}</span>

                      <FaChevronDown
                        size={14}
                        style={{
                          transform: isMobileActive
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.2s ease",
                        }}
                      />
                    </button>
                  ) : item.href ? (
                    <Link
                      to={item.href}
                      className="mobile-main-btn"
                      onClick={closeMobileMenu}
                      {...getLinkProps(item.href)}
                    >
                      <span>{item.label}</span>
                    </Link>
                  ) : (
                    <button type="button" className="mobile-main-btn">
                      <span>{item.label}</span>
                    </button>
                  )}

                  {hasDropdown && isMobileActive && (
                    <div className="mobile-sub">
                      {item.type === "nested" ? (
                        item.items.map((sector, sIdx) => {
                          const councils = Array.isArray(sector.councils)
                            ? sector.councils
                            : [];

                          return (
                            <div
                              key={sector.label}
                              className="mobile-sector-block"
                            >
                              <button
                                type="button"
                                className="mobile-sector-btn"
                                onClick={() =>
                                  setMobileNestedSub(
                                    mobileNestedSub === sIdx ? null : sIdx
                                  )
                                }
                              >
                                <span>{sector.label}</span>

                                <FaChevronDown
                                  size={12}
                                  style={{
                                    transform:
                                      mobileNestedSub === sIdx
                                        ? "rotate(180deg)"
                                        : "rotate(0deg)",
                                    transition: "transform 0.2s ease",
                                  }}
                                />
                              </button>

                              {mobileNestedSub === sIdx && (
                                <div className="mobile-sub-sub">
                                  {councils.map((council, cIdx) => {
                                    const councilLabel = getLabel(council);
                                    const councilHref = getHref(council);

                                    return (
                                      <Link
                                        key={`${councilLabel}-${cIdx}`}
                                        to={councilHref}
                                        className="mobile-sub-sub-link"
                                        onClick={closeMobileMenu}
                                        {...getLinkProps(councilHref)}
                                      >
                                        {councilLabel}
                                      </Link>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          );
                        })
                      ) : (
                        item.items.map((sub, i) => {
                          const subLabel = getLabel(sub);
                          const subHref = getHref(sub);

                          return (
                            <Link
                              key={`${subLabel}-${i}`}
                              to={subHref}
                              className="mobile-sub-link"
                              onClick={closeMobileMenu}
                              {...getLinkProps(subHref)}
                            >
                              {subLabel}
                            </Link>
                          );
                        })
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </header>
  );
}